<template>
  <div>
    <div :id="echartId" :style="{height:echartWidth}">
    </div>
  </div>

</template>

<script>
  //导入主题
  import EchartTheam from "./../../assets/js/echartTheam.json";
  // import * as Echart from "echarts";
// 按需引入
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core';


  export default {
    name: "EchartEvaluate",
    props: {
      echartWidth: {
        type: String,
        default: "300px"
      },
      echartEvaluateData: {
        type: [Array, Object]
      },
      echartId: {
        type: String
      }
    },
    data() {
      return {
        echartDemo: null,
        option: {
          tooltip: {
            // show:false,
            formatter:"{b}"
          },
          legend: {
            // top: '20px',
            show: false,
            data: [],
            // formatter:function (name) {
            //   console.log("这是什么",name);
            //   return 'Legend ' + name;
            // }
          },
          series: [
            {
              type: "pie",
              radius: [0, '65%'],
              data: null,
              itemStyle: {
                borderColor: "#f0f0f0",
                shadowColor: "rgba(0,0,0,.8)",
                shadowBlur: 10,
              },
              left: '10%',
              right: '10%',
              top: '0px',
              selectedOffset :30,
              label:{
                formatter:function (params) {
                  let txt=params.name;
                  return txt.split(",").join("\n");
                }
              },
            }
          ],
          textStyle: {
            fontSize: 14,
          }
        }
      }
    },
    created(){

      echarts.registerTheme('roma', EchartTheam);
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.$nextTick(() => {
          this.option.series[0].data = this.echartEvaluateData;
          this.echartEvaluateData.forEach((item, i) => {
            this.option.legend.data.push(item.name);
          });
          //console.log("当前设置为空吗?", this.option);
          let chartDom = document.getElementById(this.echartId);
          let tab4Dom = chartDom.parentElement;
          // 初次大小
          chartDom.setAttribute("style", `width:${this.echartWidth};height:${parseFloat(this.echartWidth) * .4 + 'px'}`);
          // 首绘图表
          this.echartDemo = echarts.init(chartDom, 'roma');
          this.echartDemo.setOption(this.option);
        })
      }
    },
    watch: {
      echartWidth(val, oldVal) {
        //console.log(val);
        let chartDom = document.getElementById(this.echartId);
        let tab4Dom = chartDom.parentElement;
        // 初次大小
        chartDom.setAttribute("style", `width:${val};height:${parseFloat(val) * .4 + 'px'}`);
        this.echartDemo.resize();
      },
      echartEvaluateData(val,oldVal){
        this.option.series[0].data = this.echartEvaluateData;
        this.echartEvaluateData.forEach((item, i) => {
          this.option.legend.data.push(item.name);
        });
        this.echartDemo.setOption(this.option);
      }
    }
  }
</script>

<style scoped lang="less">
  .echartDemo {
  }
</style>



// WEBPACK FOOTER //
// src/components/detail/EchartEvaluate.vue